module.exports = {
    "Empty": `\u{7A7A}\u{767D}`
};


//# sourceMappingURL=zh-TW.main.js.map
